import {

  ApplicationRef,

  ChangeDetectorRef,

  Injectable,

  NgZone,

  inject,

} from '@angular/core';

import { MonoTypeOperatorFunction, finalize } from 'rxjs';



@Injectable({ providedIn: 'root' })

export class AccountingChangeDetectionService {

  private readonly ngZone = inject(NgZone);

  private readonly appRef = inject(ApplicationRef);

  private readonly roots = new Set<ChangeDetectorRef>();

  private deferredFlushScheduled = false;

  private selectionNotifyFrame: number | null = null;



  /** Call from accounting shell layout on init; unregister on destroy. */

  registerRoot(cdr: ChangeDetectorRef): void {

    this.roots.add(cdr);

  }



  unregisterRoot(cdr: ChangeDetectorRef): void {

    this.roots.delete(cdr);

  }



  /**

   * Refresh the UI after accounting HTTP responses or local state changes.

   * Uses ApplicationRef.tick so nested router-outlet screens (alter lists, reports) update.

   * Extra deferred passes catch observeOn(asyncScheduler) and heavy row rebuilds.

   */

  notify(): void {

    this.flush();

    this.scheduleDeferredFlush();

  }



  /** Alias for {@link notify}. */

  touch(): void {

    this.notify();

  }



  /** After keyboard/wheel list selection — one app tick per frame (no deferred multi-flush). */
  afterListSelectionChange(): void {
    if (this.selectionNotifyFrame != null) {
      return;
    }

    this.selectionNotifyFrame = requestAnimationFrame(() => {
      this.selectionNotifyFrame = null;
      this.ngZone.run(() => {
        try {
          this.appRef.tick();
        } catch {
          /* view destroyed during navigation */
        }
      });
    });
  }



  /** Pipe operator for accounting HTTP observables that bypass the interceptor. */

  afterResponse<T>(): MonoTypeOperatorFunction<T> {

    return (source) => source.pipe(finalize(() => this.notify()));

  }



  private scheduleDeferredFlush(): void {

    if (this.deferredFlushScheduled) {

      return;

    }



    this.deferredFlushScheduled = true;

    globalThis.setTimeout(() => {

      this.deferredFlushScheduled = false;

      this.flush();

    }, 0);



    requestAnimationFrame(() => this.flush());

  }



  private flush(): void {

    this.ngZone.run(() => {

      try {

        this.appRef.tick();

      } catch {

        /* view destroyed during navigation */

      }



      for (const cdr of [...this.roots]) {

        try {

          cdr.detectChanges();

        } catch {

          this.roots.delete(cdr);

        }

      }

    });

  }

}


